(function(){
       'use strict';
    jQuery(document).ready(function() {

        jQuery("#slider-range").slider({
            range: true,
            min: 500,
            max: 999999,
            values: [500, 999999],
            slide: function(event, ui) {
                jQuery("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            },
            change: function(event, ui) {
                $("#loading").show(400);
                var max_price = ui.values[1];
                var min_price = ui.values[0];
                var check = 1;
                jQuery("#list-product").empty();
                jQuery.each(json_collection,function(index, elem) {
                    if (check <= 10) {
                        if (elem.price <= max_price && elem.price >= min_price) {
                            search_html(elem);
                        }
                    }
                    check++;
                });

                window.setTimeout(function() {
                    jQuery("#loading").hide(400);
                }, 1000);
            }
        });
        function search_html(data){
            var $html = '<div class="col-md-3"><img src="'+data.images[0]+'" width="200" /> </div>';
            $html  = $html + '<div class="col-md-9"> <a href="/products/'+data.handle+'"> <h4> '+data.title+'  </h4> </a> <p> Price <strong >'+data.price+'</strong> </p> <p> '+data.description+' </p></div>';
            $html = '<div class="row"><div class="search_item"> '+$html+'  </div> </div>';
            jQuery("#list-product").append($html);
        }
        jQuery("#amount").val("$" + jQuery("#slider-range").slider("values", 0) + " - $" + jQuery("#slider-range").slider("values", 1));
    });
    })(jQuery);
